module.exports = __webpack_public_path__ + "img/shipo-icon-truck.9d8b044d.svg";